var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticStyle: { color: "red" } }, [
        _vm._v(
          "（优先级：临时活动 > 会员日优惠 > 大客户群优惠 > 普通会员优惠）"
        )
      ]),
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.activeName,
            callback: function($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName"
          }
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "普通会员优惠", name: "SvcDiscountBase" } },
            [
              _c(
                "keep-alive",
                [
                  _vm.activeName == "SvcDiscountBase"
                    ? _c("SvcDiscountBase")
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "大客户群优惠", name: "SvcDiscountGroupBase" } },
            [
              _c(
                "keep-alive",
                [
                  _vm.activeName == "SvcDiscountGroupBase"
                    ? _c("SvcDiscountGroupBase")
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "会员日优惠", name: "SvcDiscountInterval" } },
            [
              _c(
                "keep-alive",
                [
                  _vm.activeName == "SvcDiscountInterval"
                    ? _c("SvcDiscountInterval")
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "临时活动", name: "SvcDiscountActivity" } },
            [
              _c(
                "keep-alive",
                [
                  _vm.activeName == "SvcDiscountActivity"
                    ? _c("SvcDiscountActivity")
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }